import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';

@Component({
  selector: 'app-forgot-mail',
  templateUrl: './forgot-mail.component.html',
  styleUrls: ['./forgot-mail.component.scss']
})
export class ForgotMailComponent {
  public show: boolean = false;
  public numeroDocumento: number;
  public mail: string;

  constructor(
    public router: Router,
    private authService: LoginService
  ) { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  resetPassword() {
    this.authService.forgotMail(this.numeroDocumento).subscribe((resp) => {
      if (resp.isSuccess) {
        this.router.navigateByUrl('login')
      }
    })
  }

}
